module.exports = __webpack_public_path__ + "static/ourValues@2x-261bedc6d8cf5ad94569a3e941f18798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/ourValues@2x.jpg
// module id = 2526
// module chunks = 168707334958949